export default __webpack_public_path__ + "images/b75df8bf2ed8d485fc0a630163cf3f62-thrive-complete-english.svg";